import React from "react";
import "./pcos.scss";
import { liheart } from "../../../assets/icons";
import { PublicService } from "../../../services";
import { useQuery } from "@tanstack/react-query";
import { pocosImageLeft, pocosImageRight } from "../../../assets/images";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import FAQ from "../../home/section/FAQ";

const Pcos = () => {
  const schemaData =  {
 "@context": "https://schema.org",
 "@graph": [
   {
     "@type": "MedicalCondition",
     "name": "PCOS",
     "alternateName": "Polycystic Ovary Syndrome",
     "description": "Learn about PCOS; its symptoms, causes, diagnosis, and treatment options. Get personalized guidance from women’s health homeopathy experts and start managing your PCOS naturally today. ",
     "url": "https://holypills.in/pcos-symptoms-causes-treatment",
     "mainEntityOfPage": "https://holypills.in/pcos-symptoms-causes-treatment",
     "associatedAnatomy": {
       "@type": "AnatomicalStructure",
       "name": "Ovaries"
     },
     "possibleTreatment": {
       "@type": "MedicalTherapy",
       "name": "Homeopathy"
     },
     "signOrSymptom": [
       { "@type": "MedicalSignOrSymptom", "name": "Irregular or missed periods" },
       { "@type": "MedicalSignOrSymptom", "name": "Excessive hair growth (face, chest, back)" },
       { "@type": "MedicalSignOrSymptom", "name": "Acne and oily skin" },
       { "@type": "MedicalSignOrSymptom", "name": "Weight gain and difficulty losing weight" },
       { "@type": "MedicalSignOrSymptom", "name": "Thinning hair or hair loss" },
       { "@type": "MedicalSignOrSymptom", "name": "Mood swings and depression" },
       { "@type": "MedicalSignOrSymptom", "name": "Dark patches on the skin (Acanthosis Nigricans)" }
     ]
   }
 ]
};

  const faqData = {
 "@context": "https://schema.org",
 "@type": "FAQPage",
 "mainEntity": [{
   "@type": "Question",
   "name": "What is PCOS treatment?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "PCOS treatment focuses on managing symptoms such as irregular periods, weight gain, acne, and fertility issues. Homeopathy treatment for PCOS aims to address hormonal imbalances and improve overall health rather than just suppressing symptoms."
   }
 },{
   "@type": "Question",
   "name": "How long does PCOS treatment take?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "The duration of PCOS treatment varies from person to person. Since it's a chronic hormonal condition, results may take a few months to show. With PCOS homeopathy treatment, many women report improvements in menstrual regularity, energy, and metabolism within 3-6 months."
   }
 },{
   "@type": "Question",
   "name": "Is homeopathy treatment good for PCOS?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Yes. Many people get confused and think, Can homeopathy cure PCOS? Many women have found it effective because homeopathy provides natural and long-term solutions. This approach works on the body's self-healing ability, aiming to correct irregular cycles and balance hormones."
   }
 },{
   "@type": "Question",
   "name": "What symptoms of PCOS can homeopathy help with?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Homeopathy may help with irregular or absent periods, unwanted hair growth (hirsutism), weight issues, acne, ovarian cysts, and emotional symptoms such as stress, anxiety, or depression, often associated with PCOS."
   }
   }
 ]
};


  const { healthPage } = PublicService();

  const pcosQuery = useQuery({
    queryKey: ["pcos"],
    queryFn: () => healthPage({ category: "pcos" }),
  });

  const detail = pcosQuery?.data?.data?.content;

  return (
    <>
      <Helmet defer={false}>
        <title>
          PCOS (Polycystic Ovary Syndrome) – Symptoms, Causes & Effective
          Homeopathy Treatments
        </title>
        <meta
          name="description"
          content="Learn about PCOS; its symptoms, causes, diagnosis, and treatment options. Get personalized guidance from women’s health homeopathy experts and start managing your PCOS naturally today."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link
          rel="canonical"
          href="https://holypills.in/pcos-symptoms-causes-treatment"
        />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="PCOS (Polycystic Ovary Syndrome) – Symptoms, Causes & Effective Homeopathy Treatments"
        />
        <meta
          property="og:description"
          content="Learn about PCOS; its symptoms, causes, diagnosis, and treatment options. Get personalized guidance from women’s health homeopathy experts and start managing your PCOS naturally today."
        />

        <meta
          property="og:url"
          content="https://holypills.in/pcos-symptoms-causes-treatment"
        />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="PCOS (Polycystic Ovary Syndrome) – Symptoms, Causes & Effective Homeopathy Treatments"
        />
        <meta
          name="twitter:description"
          content="Learn about PCOS; its symptoms, causes, diagnosis, and treatment options. Get personalized guidance from women’s health homeopathy experts and start managing your PCOS naturally today."
        />

        <meta
          name="twitter:url"
          content="https://holypills.in/pcos-symptoms-causes-treatment"
        ></meta>
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">{JSON.stringify(faqData)}</script>
      </Helmet>

      <div className="wrapper_pcos_page">
        {/* <section className="wrap_pcos_banner">
        <figure>
          <img src={detail?.banner?.image} alt="" />
        </figure>
      </section> */}
        <section className="banner_sec">
          <div className="container">
            <div className="inner_part">
              <div className="left_part">
                <div className="left_image">
                  <figure>
                    <img src={pocosImageLeft} alt="banner-image" />
                  </figure>
                </div>
              </div>
              <div className="right_part">
                <div className="right_img">
                  <figure>
                    <img src={pocosImageRight} alt="banner-image" />
                  </figure>
                </div>
              </div>
              <div className="banner_content">
                <h1>
                  PCOS (Polycystic <br /> Ovary Syndrome)
                  <span>Symptoms, Causes & Homeopathy Treatments</span>
                </h1>

                <p>
                  Learn about PCOS; its symptoms, causes, diagnosis, and
                  treatment options. Get personalized guidance from women’s
                  health homeopathy experts and start managing your PCOS
                  naturally today.
                </p>
                {/* <div className="btn-box">
                  <Link to="/login" className="button blue">
                    Talk To Our Experts
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_left">
                <h2>{detail?.whatIsSection?.title}</h2>
                <p>{detail?.whatIsSection?.description}</p>
                <ul>
                  {detail?.whatIsSection?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={detail?.whatIsSection?.image} alt="icon" />
                </figure>
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Symptoms spacing">
          <div className="container">
            <div className="wrap_symptoms_card">
              <div className="page_title">
                <h2>{detail?.commonSigns?.title}</h2>
                <p>{detail?.commonSigns?.description}</p>
              </div>
              <div className="wrap_btn_card">
                {detail?.commonSigns?.signs.map((item, index) => (
                  <button key={index} className={index === 1 ? "" : ""}>
                    {item}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos wrapper_what_cause spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_right">
                <figure>
                  <img src={detail?.causesSection?.image} alt="causes-image" />
                </figure>
              </div>
              <div className="wrap_left">
                <h2>{detail?.causesSection?.title}</h2>
                <p>{detail?.causesSection?.description}</p>
                {/* <p>
                Polycystic ovary syndrome (PCOS) is a problem with hormones that
                happens during the reproductive years. If you have PCOS, you may
                not have periods very often. Or you may have periods that last
                many days. You may also have too much of a hormone called
                androgen in your body.
              </p>
              <p>
                With PCOS, many small sacs of fluid develop along the outer edge
                of the ovary. These are called cysts. The small fluid-filled
                cysts contain immature eggs, called follicles. The follicles
                fail to regularly release eggs.
              </p> */}
                <ul>
                  {detail?.causesSection?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <div className="wrap_txt">
                        <p>{item?.title}</p>
                        <span>{item?.description}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Symptoms wrapper_help spacing">
          <div className="container">
            <div className="wrap_symptoms_card">
              <div className="page_title">
                <h2>{detail?.howToManage?.title}</h2>
                <p>{detail?.howToManage?.description}</p>
              </div>
              <div className="wrap_btn_card">
                {detail?.howToManage?.features.map((item, index) => (
                  <button key={index}>
                    <img src={item?.image} alt="image" />
                    <span>{item.title}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos wrapper_pcos_system spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_left">
                <h2>{detail?.howToReduce?.title}</h2>
                <p>{detail?.howToReduce?.description}</p>
                <ul>
                  {detail?.howToReduce?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={detail?.howToReduce?.image} alt="reduce-image" />
                </figure>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="expert_sec">
          <div className="container">
            <div className="page_title">
              <h2>
                Need Expert Guidance To Manage PCOS? <br /> Our doctors provide
                tailored treatment and lifestyle recommendations.
              </h2>
              <div className="btn-box">
                <Link to="/login" className="button blue">
                  Schedule a Consultation
                </Link>
              </div>
            </div>
          </div>
        </section> */}

        {/* FAQ */}
        <FAQ type={"pcos"} />
      </div>
    </>
  );
};

export default Pcos;
